import { render, staticRenderFns } from "./reviewReportManage.vue?vue&type=template&id=5a9099c0&scoped=true&"
import script from "./reviewReportManage.vue?vue&type=script&lang=js&"
export * from "./reviewReportManage.vue?vue&type=script&lang=js&"
import style0 from "./reviewReportManage.vue?vue&type=style&index=0&id=5a9099c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9099c0",
  null
  
)

export default component.exports